import * as z from 'zod/mini'

import type { PageAdSize, PageAdType } from './types'

export const AdvancedBannerSchema = z.object({
    bottom: z.optional(z.string()),
    height: z.string(),
    left: z.optional(z.string()),
    right: z.optional(z.string()),
    top: z.optional(z.string()),
    width: z.string(),
})

export const AdvancedBannersSchema = z.array(AdvancedBannerSchema)

export type AdvancedBannerOptions = z.infer<typeof AdvancedBannerSchema>

export type AdvancedBannerPositionNormalized = {
    height: string
    left: string
    top: string
    width: string
}

export const ADVANCED_BANNER_TYPES = [
    'universal_banner_1',
    'universal_banner_2',
] as const satisfies readonly PageAdType[]

export const ADVANCED_BANNER_SIZES: PageAdSize[] = [
    [960, 90],
    [300, 600],
    [970, 90],
    [300, 250],
    [336, 280],
    [320, 100],
    [950, 90],
    [320, 480],
    [300, 50],
    [480, 320],
    [300, 300],
    [728, 90],
    [120, 600],
    [320, 50],
    [160, 600],
    [300, 100],
    [980, 90],
]

function parsePercentValue(value: string | undefined): number {
    return value ? parseFloat(value) || 0 : 0
}

export function normalizeAdvancedBannerPosition(banner: AdvancedBannerOptions): AdvancedBannerPositionNormalized {
    const width = parsePercentValue(banner.width)
    const height = parsePercentValue(banner.height)
    const top = banner.top ? parsePercentValue(banner.top) : 100 - parsePercentValue(banner.bottom) - height
    const left = banner.left ? parsePercentValue(banner.left) : 100 - parsePercentValue(banner.right) - width

    return {
        height: banner.height,
        left: `${left}%`,
        top: `${top}%`,
        width: banner.width,
    }
}
